export default "__VITE_ASSET__18bbc307__$_?component__"